import { IconoVolver } from '../../componentes/iconos'
import type { ClienteResumen } from '../../hooks/useClientes'

interface Props {
  cliente: ClienteResumen
  seleccionado: boolean
  onSeleccionar: (cliente: ClienteResumen) => void
}

/**
 * Version movil de una fila. Una tabla de cinco columnas a 375 px obliga a
 * desplazarse en horizontal para leer un solo cliente; la tarjeta da los tres
 * datos que se usan en la calle: nombre, movil y poblacion.
 */
export function TarjetaCliente({ cliente, seleccionado, onSeleccionar }: Props) {
  return (
    <li>
      <button
        type="button"
        aria-current={seleccionado ? 'true' : undefined}
        onClick={() => onSeleccionar(cliente)}
        className={[
          'flex w-full items-center gap-3 rounded-xl border px-4 py-3 text-left transition-colors',
          seleccionado
            ? 'border-acento-borde bg-acento-suave'
            : 'border-borde bg-superficie hover:border-borde-fuerte',
        ].join(' ')}
      >
        <span className="min-w-0 flex-1">
          <span className="block truncate text-sm font-medium text-tinta">
            {cliente.nombre}
          </span>
          <span className="mt-0.5 block truncate text-sm text-tinta-apagada">
            {[cliente.movil, cliente.ciudad].filter(Boolean).join(' - ') || 'Sin datos de contacto'}
          </span>
        </span>
        {/* Chevron girado: apunta hacia donde se abre el detalle. */}
        <IconoVolver aria-hidden="true" className="size-4 shrink-0 rotate-180 text-tinta-apagada" />
      </button>
    </li>
  )
}
